import { render, staticRenderFns } from "./ProductBasketbutton.vue?vue&type=template&id=95d4a35e&"
import script from "./ProductBasketbutton.vue?vue&type=script&lang=js&"
export * from "./ProductBasketbutton.vue?vue&type=script&lang=js&"
import style0 from "./ProductBasketbutton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports